export default __webpack_public_path__ + "media/images/series-a-news/estadao-logo-d0d3c0e4523e78f1d6503263686900af.svg";